import React, { Component } from 'react';
import styled from 'styled-components';

import { Text } from '../Text';

const getHoverColor = (isDisabled, hoverColor, disabledColor) => {
  return isDisabled ? disabledColor : hoverColor;
};

const LinkView = styled(({ disabledColor, ...restProps }) => <Text {...restProps} />)`
  color: ${(props) =>
    props.disabled ? props.disabledColor || props.theme.colors.greyscale.grey3 : props.color};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  &:hover {
    text-decoration: underline;
    color: ${(props) =>
      getHoverColor(
        props.disabled,
        props.hoverColor || props.theme.colors.primary,
        props.disabledColor || props.theme.colors.greyscale.grey3
      )};
  }
`;
class Link extends Component {
  handleClick = (data) => {
    const { disabled, onClick } = this.props;
    if (!disabled && onClick && typeof onClick === 'function') {
      onClick(data);
    }
  };
  render() {
    return <LinkView {...this.props} onClick={this.handleClick} />;
  }
}

export default Link;
